<template>
  <section class="full-height">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <b-tabs v-model="activeTab" :class="{ 'sub-tabs-active': activeTab >= 11 }">
      <b-tab-item :label="$t('Tipo de organización')">
        <b-table :data="objectArrayToList(dataOptions.investorCompanyTypes)">
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>

      <b-tab-item :label="$t('Jurisdicción operativa positiva')">
        <b-table :data="dataOptions.countries">
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>

      <b-tab-item :label="$t('Sector actividad operativa')">
        <b-table :data="objectArrayToList(dataOptions.businessSectors)">
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>

      <b-tab-item
        :label="$t('Tipos de programas de capital en Recaudación/Fundraising')"
      >
        <b-table
          :data="objectArrayToList(dataOptions.fundraisingOportunityPhases)"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item :label="$t('Tipo de organización aceptadas')">
        <b-table :data="objectArrayToList(dataOptions.requesterCompanyTypes)">
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item
        :label="$t('Tipos de programas de capital en Recaudación/Fundraising')"
      >
        <b-table :data="objectArrayToList(dataOptions.fundraisingProgramTypes)">
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item :label="$t('Criterios de Divisas o Moneda Programa')">
        <b-table :data="objectArrayToList(dataOptions.programCurrencyTypes)">
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item :label="$t('Criterios auditor de cuentas')">
        <b-table
          :data="
            tableDataToListFormat(dataOptions.formQuestions.hasAccountAuditor)
          "
        >
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item :label="$t('Criterios de importes de programas de Capital')">
        <b-table
          :data="tableDataToListFormat(dataOptions.requestedAmountRanges)"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item :label="$t('Criterios de Cifra de EBITDA para organización')">
        <b-table :data="objectArrayToList(dataOptions.ebidtaAmountRanges)">
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item :label="$t('Criterios de importes de Ventas/Facturación')">
        <b-table :data="tableDataToListFormat(dataOptions.sellsAmountRanges)">
          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="title" label="Keyword">
              {{ $t(props.row.id) }}
            </b-table-column>
            <b-table-column field="allowed" :label="$t('allowed')">
              <b-field>
                <b-select
                  :id="props.row.id"
                  :value="bannedState(props.row.id)"
                  @input.native="updateBannedState"
                >
                  <option value="yes">{{ $t('yes') }}</option>
                  <option value="no">{{ $t('no') }}</option>
                  <option value="maybe">{{ $t('maybe') }}</option>
                </b-select>
              </b-field>
            </b-table-column>
          </template>
        </b-table>
      </b-tab-item>
      <b-tab-item :label="$t('Sector actividad operativa detallados')">
        <a @click="activeTab = 0">{{ $t('back') }}</a>
        <b-tabs class="is-vertical" :size="'small'">
          <b-tab-item
            :key="sector"
            v-for="sector of Object.keys(dataOptions.detailedBusinessSectors)"
            :label="$t(sector)"
          >
            <b-table :data="dataOptions.detailedBusinessSectors[sector]">
              <template slot-scope="props">
                <b-table-column field="id" label="ID" width="40" numeric>
                  {{ props.row }}
                </b-table-column>
                <b-table-column field="title" label="Keyword">
                  {{ $t(props.row) }}
                </b-table-column>
                <b-table-column field="allowed" :label="$t('allowed')">
                  <b-field>
                    <b-select
                      :id="props.row"
                      :value="bannedState(props.row)"
                      @input.native="updateBannedState"
                    >
                      <option value="yes">{{ $t('yes') }}</option>
                      <option value="no">{{ $t('no') }}</option>
                      <option value="maybe">{{ $t('maybe') }}</option>
                    </b-select>
                  </b-field>
                </b-table-column>
              </template>
            </b-table>
          </b-tab-item>
        </b-tabs>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import InvestorCompanyTypes from '@/constants/investor_company_types.js'
import Countries from '@/constants/countries.js'
import EnumeratesFormater from '@/mixins/enumeratesFormater.js'
import BusinessSectors from '@/constants/business_sectors.js'
import DetailedBusinessSectors from '@/constants/detailed_business_sectors.js'
import FundraisingProgramTypes from '@/constants/fundraising_program_types.js'
import RequesterCompanyTypes from '@/constants/requester_company_types.js'
import RequestedAmountRanges from '@/constants/requested_amount_ranges.js'
import EbidtaAmountRanges from '@/constants/ebidta_amount_ranges.js'
import SellsAmountRanges from '@/constants/sells_amount_ranges.js'
import ProgramCurrencyTypes from '@/constants/program_currency_types.js'
import FormQuestions from '@/constants/form_questions.js'
import FundraisingOportunityPhases from '@/constants/fundraising_oportunity_phases.js'

export default {
  mixins: [EnumeratesFormater],
  data() {
    return {
      bannedKeywords: [],
      isLoading: false,
      detailedBusinessSectorsActiveIndex: 0,
      activeTab: 0,
      dataOptions: {
        countries: null,
        investorCompanyTypes: null,
        businessSectors: null,
        detailedBusinessSectors: null,
        fundraisingProgramTypes: null,
        requesterCompanyTypes: null,
        requestedAmountRanges: null,
        ebidtaAmountRanges: null,
        sellsAmountRanges: null,
        programCurrencyTypes: null,
        fundraisingOportunityPhases: null,
        formQuestions: null
      }
    }
  },

  methods: {
    ...mapActions('institutions', [
      'postBanKeyword',
      'getBannedKeywords',
      'deleteUnbanKeyword'
    ]),
    keywordBanUpdated: function(keyword) {
      if (!(keyword in this.bannedKeywords)) {
        this.unbanKeyword(keyword)
      } else {
        this.banKeyword(keyword)
      }
    },
    isBanned: function(keyword) {
      return !(keyword in this.bannedKeywords)
    },
    bannedState: function(keyword) {
      if (!(keyword in this.bannedKeywords)) {
        return 'yes'
      } else {
        return this.bannedKeywords[keyword]
      }
    },
    updateBannedState: function(e) {
      let newVal = e.target.value
      let keyword = e.target.id
      if (newVal != 'yes') {
        this.banKeyword(keyword, newVal)
      } else {
        this.unbanKeyword(keyword)
      }
    },
    banKeyword: function(k, s) {
      let self = this
      this.postBanKeyword({ keyword: k, status: s })
        .then(function(response) {
          self.bannedKeywords[response.keyword] = s
        })
        .catch(function(error) {
          alert(error)
        })
    },
    unbanKeyword: function(k) {
      let self = this
      this.deleteUnbanKeyword({ keyword: k })
        .then(function(response) {
          delete self.bannedKeywords[response.keyword]
        })
        .catch(function(error) {
          alert(error)
        })
    }
  },
  created() {
    let self = this
    self.dataOptions = {
      countries: this.formatWorldCountries(Countries),
      investorCompanyTypes: InvestorCompanyTypes,
      businessSectors: BusinessSectors,
      detailedBusinessSectors: DetailedBusinessSectors,
      fundraisingProgramTypes: FundraisingProgramTypes,
      requesterCompanyTypes: RequesterCompanyTypes,
      requestedAmountRanges: RequestedAmountRanges,
      ebidtaAmountRanges: EbidtaAmountRanges,
      sellsAmountRanges: SellsAmountRanges,
      programCurrencyTypes: ProgramCurrencyTypes,
      fundraisingOportunityPhases: FundraisingOportunityPhases,
      formQuestions: FormQuestions
    }
    this.isLoading = true
    this.getBannedKeywords()
      .then(function(response) {
        console.log(response)
        self.bannedKeywords = response
      })
      .catch(function(error) {
        console.log(error)
      })
      .then(function() {
        self.isLoading = false
      })
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', this.$t('Enumerados')],
      title: this.$t(this.$t('Enumerados'))
    })
  }
}
</script>

<style lang="scss">

@media (max-width: 768px) {
  .table.has-mobile-cards {
    display: flex;
    
    tbody {
      width: 100%;
    }
  }
}
</style>
